import { render, staticRenderFns } from "./tAlert.vue?vue&type=template&id=55b7f595&scoped=true"
import script from "./tAlert.vue?vue&type=script&lang=js"
export * from "./tAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b7f595",
  null
  
)

export default component.exports